import { render, staticRenderFns } from "./BookRepair.vue?vue&type=template&id=4ffb3527&"
import script from "./BookRepair.vue?vue&type=script&lang=js&"
export * from "./BookRepair.vue?vue&type=script&lang=js&"
import style0 from "./BookRepair.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports